export const GET_FILTER_SERVICE_REQUEST = "GET_FILTER_SERVICE_REQUEST";
export const GET_FILTER_SERVICE_SUCCESS = "GET_FILTER_SERVICE_SUCCESS";
export const GET_FILTER_SERVICE_FAILURE = "GET_FILTER_SERVICE_FAILURE";
